export const GET_SOLMAN_STAGING_CONFIG_LIST = 'GET_SOLMAN_STAGING_CONFIG_LIST';
export const SET_SOLMAN_STAGING_CONFIG_LIST = 'SET_SOLMAN_STAGING_CONFIG_LIST';
